import Vue from 'vue'
import { apiConfig } from './requestapis'
import { configkey } from './configkey'
import { setCath } from './cache'
import { BASEURL } from './realmName'
import { syncServerTime } from './marketClock'

export const systemConfig = Vue.observable({ data: {}, ready: false, error: '', loading: false })
let pending, loadedAt = 0, loadedFor = '', generation = 0
export function resetSystemConfig() {
  generation++; pending = null; loadedAt = 0; loadedFor = ''
  systemConfig.data = {}; systemConfig.ready = false; systemConfig.error = ''; systemConfig.loading = false
}
export function loadSystemConfig(force = false) {
  if (pending && !force) return pending
  const version = ++generation
  const identity = BASEURL()
  if (loadedFor !== identity) systemConfig.ready = false
  if (!force && systemConfig.ready && Date.now() - loadedAt < 30000) return Promise.resolve(systemConfig.data)
  systemConfig.loading = true
  const requestedAt = performance.now()
  pending = apiConfig({ config_keys: configkey() }).then(result => {
    if (version !== generation) throw Error('配置请求已失效')
    if (identity !== BASEURL()) throw Error('接口环境已切换，请重试')
    const data = result && (result.data || result)
    if (!data || !data.site || !data.app || !data.trade) throw Error('系统配置加载失败')
    syncServerTime(data.server_time, requestedAt)
    systemConfig.data = data; systemConfig.ready = true; systemConfig.error = ''; loadedAt = Date.now(); loadedFor = identity
    setCath('config_data', data)
    return data
  }).catch(error => { if (version === generation) { systemConfig.ready = false; systemConfig.error = '系统配置加载失败，请重试' } throw error })
    .finally(() => { if (version === generation) { pending = null; systemConfig.loading = false } })
  return pending
}
export function configEnabled(group, key) { return systemConfig.ready && Number((systemConfig.data[group] || {})[key]) === 1 }
export function marketEnabled(market) {
  return systemConfig.ready && (market === 'cn' || ({ hk: configEnabled('trade', 'stock_hk_service'), us: configEnabled('trade', 'stock_us_service'), index: configEnabled('trade', 'stock_index_service'), guess: configEnabled('stock_index_prediction', 'stock_index_prediction_entry_switch') })[market] === true)
}
